export class CustomParamsReferralTypeModel {
  ReferralType: number;
}
